import {Modal, Table} from "antd";
import React from "react";

const UnreceivedModal = ({
    isUnreceivedModalOpen,
    setIsUnreceivedModalOpen,
    unreceivedModalData
}) => {
    return (
        <Modal
            visible={isUnreceivedModalOpen}
            onCancel={() => setIsUnreceivedModalOpen(false)}
            width={800}
            footer={null}
        >
            <h3 style={{marginBottom: 20}}>Okutulmayan Paketler Bulunmaktadır!</h3>
            <Table
                dataSource={unreceivedModalData?.unreceivedShipments}
                scroll={{x: "max-content"}}
            >
                <Table.Column title="Barkod" dataIndex="barcodeNumber" />
                <Table.Column
                    title="Toplam Paket Sayısı"
                    dataIndex="scannedCount"
                    render={text => <span>{text} Paket</span>}
                />
                <Table.Column
                    title="Okutulmayan Paket Sayısı"
                    dataIndex="scannedCount"
                    render={(text, record) => <span>{text - record?.receivedCount} Paket</span>}
                />
                <Table.Column
                    title="Kayıp Paket Sayısı"
                    dataIndex="missingCount"
                    render={text => <span>{text} Paket</span>}
                />
            </Table>
        </Modal>
    );
};

export default UnreceivedModal;
